module.exports = __webpack_public_path__ + "img/Number=30.a9189563.png";